import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=42b12ef3&scoped=true"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b12ef3",
  null
  
)

export default component.exports